import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import { environment } from '../connector/environment';
@Injectable()

export class StaticConstantsProvider {

    // --- V2 VM_OPA --- 
    private vhost_alias = environment.vhost_alias;
    public GetCapabilitiesURL: string = this.vhost_alias + "/cgi-bin/mapserv?SERVICE=WMS&REQUEST=GetCapabilities&VERSION=1.3.0&STYLES&MAP=/srv/ov/backend/mapfiles/cascade/CASCADE.map"
    public WMSServerURL: string = this.vhost_alias + "/cgi-bin/mapserv?"
    public configurationURL: string = this.vhost_alias+"/backend/config.php"
    public pngURL = this.vhost_alias+"/backend/data/regions/"
    public masksURL = this.vhost_alias+"/backend/support/masks-json/";
    public dynBaseURL: string = this.vhost_alias+'/backend/dynpal/?'
    public getFeatureInfoURL: string = this.vhost_alias+'/backend/PALETTE/template/cascade/getFeatureInfo.php/?MAP=/srv/ov/backend/mapfiles/cascade/CASCADE.map&service=WMS&request=GetFeatureInfo&version=1.3.0&'

    // --- common --- 
    public ColorbarURL: string = this.vhost_alias+'backend/PALETTE/colorbar.php'
    // public ColorbarURL: string = this.vhost_alias+'/backend/PALETTE/colorbar.php'

    // // ********* gturrisi CONF ********* 

    public BaseMaps: any = {
      // Satellite base map
      Satellite: {
        url: "http://geoserver.myocean.eu/geoserver/wms?",
        opts: {
            // layers: 'nasa:bluemarble'
            // layers: "GEBCO_LATEST",
            layers: "cls:noaa_blue_marble"
        },
      },

      // Hybrid base map
      Hybrid: {
        url: 'https://ows.terrestris.de/osm/service?',
        opts: {
            layers: 'OSM-WMS',
            format: 'image/png',
        },
      },

      // ESRI basemaps: https://esri.github.io/esri-leaflet/api-reference/layers/basemap-layer.html
      ESRI_sat: {
        name: 'Imagery'//'ImageryFirefly'//'Imagery'
      },
      ESRI_hyb: {
        name: 'Topographic'  //'Oceans'  //'Gray'  //'NationalGeographic'  //'Topographic'  //'Streets'  //'Topographic'
      },
      ESRI_lbl_sat: {
        name: 'ImageryLabels'
      },
      ESRI_lbl_hyb: {
        name: 'OceansLabels'
      }
    };

    constructor() {
      
    }
}



// WEBPACK FOOTER //
// ./src/providers/static-constants/static-constants.ts